import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { appStateTypes } from "../../../types/merchantDetails";

const initialState: appStateTypes = {
  isSubmited: false,
  selectedBank: "",
  htmlContent: "",
  isPopupOpen: false,
  readyToPay: false,
  isProceeded: false,
};

const appStateSlice = createSlice({
  name: "appState",
  initialState,
  reducers: {
    setIsSubmitted: (state, action: PayloadAction<boolean>) => {
      state.isSubmited = action.payload;
    },

    setSelectedBank: (state, action: PayloadAction<string>) => {
      state.selectedBank = action.payload;
    },

    setHtmlContent: (state, action: PayloadAction<string>) => {
      state.htmlContent = action.payload;
    },
    setIsPopupOpen: (state, action: PayloadAction<boolean>) => {
      state.isPopupOpen = action.payload;
    },
    setReadyToPay: (state, action: PayloadAction<boolean>) => {
      state.readyToPay = action.payload;
    },
    setProceeded: (state, action: PayloadAction<boolean>) => {
      state.isProceeded = action.payload;
    },

    // Resets the state to initial values
    resetAppState: () => initialState,
  },
});

// Export actions
export const {
  setIsSubmitted,
  setSelectedBank,
  resetAppState,
  setHtmlContent,
  setIsPopupOpen,
  setReadyToPay,
  setProceeded,
} = appStateSlice.actions;

// Export reducer
export default appStateSlice.reducer;
